/// @ts-ignore shut up
import Glossary from './components/Glossary.svelte';
if (typeof customElements !== 'undefined') {
    customElements.define('ewiko-glossar', class extends HTMLElement {
        constructor() {
            super();
            this.component = null;
        }
        get glossaryId() {
            return this.getAttribute('glossar-id');
        }
        async connectedCallback() {
            const innerText = this.innerText;
            this.innerText = '';
            this.component = new Glossary({
                target: this,
                props: {
                    glossaryId: this.glossaryId,
                    innerText: innerText,
                },
            });
        }
        disconnectedCallback() {
            var _a;
            (_a = this.component) === null || _a === void 0 ? void 0 : _a.$destroy();
        }
    });
}
